"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDeserialize = void 0;
/**
 * Deserializes an object in to an interface while adhering to converting to date objects, assuming
 * it matches a regex that would match 2026-02-23T.
 * @param serializedValue The value as serialized that will be deserialized with date objects.
 *
 * @returns A deserialized object as type T with date strings replaced with dates.
 */
function dateDeserialize(serializedValue) {
    return JSON.parse(serializedValue, (_, val) => {
        // Revive dates using a regex check
        if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}T/.test(val)) {
            return new Date(val);
        }
        return val;
    });
}
exports.dateDeserialize = dateDeserialize;
